import { render, staticRenderFns } from "./ZLCardBox.vue?vue&type=template&id=7641c499&scoped=true"
import script from "./ZLCardBox.vue?vue&type=script&lang=js"
export * from "./ZLCardBox.vue?vue&type=script&lang=js"
import style0 from "./ZLCardBox.vue?vue&type=style&index=0&id=7641c499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7641c499",
  null
  
)

export default component.exports